import React from "react";
import { Navigate } from "react-router-dom";

//Dashboard
import Dashboard from "../Pages/Dashboard";

// Import Authentication pages
import Login from "../Pages/Authentication/Login";
import ForgetPasswordPage from "../Pages/Authentication/ForgetPassword";
import Logout from "../Pages/Authentication/Logout";
import Register from "../Pages/Authentication/Register";
import UserProfile from "../Pages/Authentication/user-profile";
import User from "../Pages/User";
import Authorization from "../Pages/Authorization";
import UserRegistration from "../Pages/UserRegistration";
import Insurance from "../Pages/Insurance";
import Diagnosis from "../Pages/Diagnosis";
import Provider from "../Pages/Provider";
import Patient from "../Pages/Patient";
import PatientRegistration from "../Pages/PatientRegistration";
import Demographics from "../Pages/Demographics";
// import InsurancePatient from "../Pages/InsurancePatient";
import InsuranceRegistration from "../Pages/InsuranceRegistration";
import ProviderRegistration from "../Pages/providerRegistration";
import InsurancePatient from "../Pages/InsurancePatient";
import DiagnosisRegistration from "../Pages/DiagnosisRegistration";
import Practice from "../Pages/Practice";
import PracticeRegistration from "../Pages/PracticeRegistration";
import Facilities from "../Pages/Facilities";
import FacilitiesRegistration from "../Pages/FacilitiesRegistration";

import Procedure from "../Pages/procedure";
import ProcedureRegistration from "../Pages/ProcedureRegistration";


const authProtectedRoutes = [
  //dashboard
  {
    path: "/dashboard",
    component: <Dashboard />,
  },
  {
    path: "/userprofile",
    component: <UserProfile />,
  },
  {
    path: "/",
    exact: true,
    component: <Navigate to="/login" />,
  },
  {
    path: "/User",
    component: <User />,
  },

  {
    path: "/Role",
    component: <Authorization />,
  },
  {
    path: "/UserRegistration",
    component: <UserRegistration />,
  },

  {
    path: "/Insurance",
    component: <Insurance />,
  },
  {
    path: "/Facilities",
    component: <Facilities />,
  },
 {
    path: "/FacilitiesRegistration",
    component: <FacilitiesRegistration />,
  },
  {
    path: "/ProcedureRegistration",
    component: <ProcedureRegistration />,
  },
  

  {
    path: "/InsurancePatient",
    component: <InsurancePatient />,
  },
  {
    path: "/Demographics",
    component: <Demographics />,
  },
  {
    path: "/Diagnosis",
    component: <Diagnosis />,
  },
  {
    path: "/Provider",
    component: <Provider />,
  },
  {
    path: "/InsurancePatient",
    component: <InsurancePatient />,
  },
  {
    path: "/Procedure",
    component: <Procedure />,
  },
  {
    path: "/Practice",
    component: <Practice/>,
  },
  
  {
    path: "/DiagnosisRegistration",
    component: <DiagnosisRegistration/>,
  },
  {
    path: "/InsuranceRegistration",
    component: <InsuranceRegistration />,
  },
  {
    path: "/ProviderRegistration",
    component: <ProviderRegistration />,
  },
  {
    path: "/Patient",
    component: <Patient />,
  },
  {
    path: "/PatientRegistration",
    component: <PatientRegistration />,
  },
  {
    path: "/PatientRegistration",
    component: <PatientRegistration />,
  },
  {
    path: "/Patient",
    component: <Patient />,
  },
  {
    path: "/PracticeRegistration",
    component: <PracticeRegistration/>,
  },
  
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Login /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/register", component: <Register /> },
];

export { authProtectedRoutes, publicRoutes };
